import React from 'react';

const FilterToggle = ({ filterState, setFilterState }) => {
  return (
    <div className="flex items-center bg-white rounded-lg shadow-sm p-1 mr-4">
      <button
        className={`px-3 py-1 rounded-md text-sm ${
          filterState === 'all' ? 'bg-emerald-100 text-emerald-600' : 'text-gray-500 hover:bg-gray-100'
        }`}
        onClick={() => setFilterState('all')}
      >
        All
      </button>
      <button
        className={`px-3 py-1 rounded-md text-sm ${
          filterState === 'active' ? 'bg-emerald-100 text-emerald-600' : 'text-gray-500 hover:bg-gray-100'
        }`}
        onClick={() => setFilterState('active')}
      >
        Active
      </button>
      <button
        className={`px-3 py-1 rounded-md text-sm ${
          filterState === 'completed' ? 'bg-emerald-100 text-emerald-600' : 'text-gray-500 hover:bg-gray-100'
        }`}
        onClick={() => setFilterState('completed')}
      >
        Completed
      </button>
    </div>
  );
};

export default FilterToggle; 